module.exports = __webpack_public_path__ + "img/pic09@2x.1b437719.png";